import { Controller } from "@hotwired/stimulus"

// The Slack channels the viewer is in, fetched when the picker is first opened (it is a
// Slack API call, so the project page does not make it on every load).
export default class extends Controller {
    static targets = ["select", "note", "submit"]
    static values = { url: String }

    async load() {
        if (!this.element.open || this._loaded) return
        this._loaded = true
        try {
            const response = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
            const { channels } = await response.json()
            this.selectTarget.replaceChildren(new Option(channels.length ? "Choose a channel" : "No channels found", ""))
            channels.forEach((channel) => this.selectTarget.add(new Option(`${channel.private ? "🔒 " : "#"}${channel.name}`, channel.id)))
            this.submitTarget.disabled = channels.length === 0
            if (!channels.length) this.noteTarget.textContent = "No channel to link. Connect Slack in Settings, or every channel you are in already follows a project."
        } catch (_) {
            this._loaded = false
            this.selectTarget.replaceChildren(new Option("Could not load channels", ""))
        }
    }
}
